import { GenresProvider } from "./genres";
import { MoviesProvider } from "./movies";
import { AuthProvider } from "./users";

export const Providers = ({ children }) => {
  return (
    <AuthProvider>
      <GenresProvider>
        <MoviesProvider>{children}</MoviesProvider>
      </GenresProvider>
    </AuthProvider>
  );
};
